import { StoreEnum } from "@/enums";
import { INotSure } from "@/types";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  useHFStore,
  useIndicatorStore,
  useLayerStore,
  useLGAStore,
  useMonitoringStore,
  useStateStore,
  useUtilStore,
  useWardStore,
  useZoneStore,
} from "./Stores";
import { IAppStore, IAppStoreState } from "./Types";

const createStore = () => {
  const store = create<IAppStore>()(
    devtools(
      (set) => {
        // Utility function to handle subscription
        const subscribeToStore = (
          store: INotSure,
          set: (state: IAppStoreState) => void
        ) => {
          store.subscribe((state: IAppStoreState) => {
            set(state);
          });
        };

        // Subscribe to each store using the utility function
        subscribeToStore(useUtilStore, set);
        subscribeToStore(useIndicatorStore, set);
        subscribeToStore(useLayerStore, set);
        subscribeToStore(useZoneStore, set);
        subscribeToStore(useStateStore, set);
        subscribeToStore(useLGAStore, set);
        subscribeToStore(useWardStore, set);
        subscribeToStore(useHFStore, set);
        subscribeToStore(useMonitoringStore, set);

        const utilStore = useUtilStore.getState();
        const indicatorStore = useIndicatorStore.getState();
        // const layerStore = useLayerStore.getState();
        const zoneStore = useZoneStore.getState();
        const stateStore = useStateStore.getState();
        const lgaStore = useLGAStore.getState();
        const wardStore = useWardStore.getState();
        const HFStore = useHFStore.getState();
        const monitoringStore = useMonitoringStore.getState();

        return {
          ...utilStore,
          ...indicatorStore,
          // ...layerStore,
          ...zoneStore,
          ...stateStore,
          ...lgaStore,
          ...wardStore,
          ...HFStore,
          ...monitoringStore,
        };
      },
      { name: StoreEnum.APP }
    )
  );

  return store;
};

export const useAppStore = createStore();
